import application_settings from '../applicationSettings';
import Event from './Event';

class DeleteReview extends Event {
    eventName = 'oms_DeleteReviewEvent';

    constructor() {
        super();
        this.add();
    }

    eventFunction(data) {
        let reviewId = data.reviewId;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        if (reviewId) {
            data.endPoint = application_settings.endPoints.deleteReview;
            data.method = 'POST';
            data.canUsePublicAuth = false;
            data.data = {
                id: reviewId
            };

            this.sendRequest(data, function (response) {
              if (response) {
                let data = thisObj.formatResponseData(response);
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
              }
            });

        } else {
            thisObj.onErrorEvent({ "message": "review id not received", "status": 422 }, {'action' : action, 'request_id' : requestId });
        }
    }
}

export default DeleteReview;